export const DatosUrlSeccion = [
	{
		id: 1,
		name: 'Inicio',
		url: '/home',
		seccion: 1,
		principal: true,
		icon: 'mdi:home-variant-outline',
		roles: ["super","admin", "vendedor"]
	},
	{
		id: 2,
		name: 'Venta Rapida',
		url: '/venta-realizadas',
		seccion: 2,
		principal: true,
		icon: 'mdi:point-of-sale',
		roles: ["super","admin", "vendedor"]
	},
	{
		id: 3,
		name: 'Inventario',
		url: '/inventario',
		seccion: 3,
		principal: true,
		icon: 'mdi:warehouse',
		roles: ["super"]
	},
	{
		id: 4,
		name: 'Caja menor',
		url: '/caja-menor',
		seccion: 4,
		principal: true,
		icon: 'mdi:cash-multiple',
		roles: ["super","admin", "vendedor"]
	},
	{
		id: 5,
		name: 'Empleados',
		url: '/empleado',
		seccion: 5,
		principal: true,
		icon: 'mdi:account-group-outline',
       roles: ["super","admin", "vendedor"]
	},
	{
		id: 6,
		name: 'Facturas',
		url: '/factura',
		seccion: 6,
		principal: true,
		icon: 'mdi:receipt-text-outline',
		roles: ["super","admin", "vendedor"]
	},
	{
		id: 7,
		name: 'Cotizacion',
		url: '/ver_cotizaciones',
		seccion: 7,
		principal: true,
		icon: 'mdi:file-document-edit-outline',
		roles: ["super","admin", "vendedor"]
	},
	{
		id: 8,
		name: 'detalleempleado',
		url: '/detalleempleado',
		seccion: 5,
		principal: false,
	},
	{
		id: 9,
		name: 'detallefactura',
		url: '/detallefactura',
		seccion: 6,
		principal: false,
	},
	{
		id: 10,
		name: 'carrito compra',
		url: '/carrito',
		seccion: 2,
		principal: false,
	},
	{
		id: 11,
		name: 'configuracion',
		url: '/configuracion',
		seccion: 1,
		principal: false,
	},
	{
		id: 12,
		name: 'generarfactura',
		url: '/generarfactura',
		seccion: 2,
		principal: false

	},
	{
		id: 13,
		name: 'Agenda',
		url: '/notas-agregadas?tipo=false',
		seccion: 13,
		principal: true,
		icon: 'mdi:calendar-month-outline',
		roles: ["super","admin", "vendedor"]
	},
	{
		id: 14,
		name: 'Venta Rapidas',
		url: '/venta-rapida',
		seccion: 2,
		principal: false
	},
	{
		id: 15,
		name: 'Detalle de Ventas Rapidas',
		url: '/detalle-venta',
		seccion: 2,
		principal: false
	},
	{
		id: 16,
		name: 'Cotizacion realizadas',
		url: '/cotizaciones-realizadas',
		seccion: 2,
		principal: false
	},
	{
		id: 17,
		name: 'Editar facturas',
		url: '/editar-factura',
		seccion: 2,
		principal: false
	},
	{
		id: 17,
		name: 'ver cotizacion fectura',
		url: '/cotizacion',
		seccion: 7,
		principal: false
	},
	{
		id: 18,
		name: 'editar ventas',
		url: '/editar-factura-venta',
		seccion: 6,
		principal: false
	},
	{
		id: 19,
		name: 'Alquileres',
		url: '/alquileres',
		seccion: 19,
		principal: true,
		icon: 'mdi:key-outline',
		roles: ["super","admin", "vendedor"]
	},
	{
		id: 20,
		name: 'nuevo alquiler',
		url: '/alquileres/nuevo',
		seccion: 19,
		principal: false
	}


];
